var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('error-box',{attrs:{"loading":_vm.loading},on:{"reload":function($event){return _vm.load()}}}):(_vm.loading)?_c('loader'):_vm._e(),(!_vm.error && !_vm.loading)?[_c('router-view')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }